// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { IconPlay, Type } from '@spotify-internal/encore-web';
import { itemToSearchHit } from '../../Search';
import { Link } from '../../ui';
import { spacer4, spacer8, spacer16, spacer20, spacer32, spacer40, spacer48, spacer56, spacer72, spacer80, screenXxsMax, screenXsMax, screenSmMax, screenMdMin, gray7, heading2FontSize, heading2LineHeightSmall, cta1FontWeight, heading4FontSize, heading4LineHeight, white } from '@spotify-internal/encore-foundation';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { ImageWrapper } from '../../ContentGrid/index.styles';
import { transformScaleUp } from '../../utils';
import { useLocale } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RelatedStoriesList = styled.div.withConfig({
  displayName: "RelatedStoriesListModule__RelatedStoriesList",
  componentId: "sc-1b4mfqp-0"
})(["padding:", ";background:", ";color:", ";@media (max-width:", "){padding:", " ", " ", ";}"], spacer40, function (props) {
  return props.themeName === 'whiteOnBlack' ? gray7 : 'unset';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, screenXsMax, spacer16, spacer16, spacer40);
var StyledSupertext = styled.div.withConfig({
  displayName: "RelatedStoriesListModule__StyledSupertext",
  componentId: "sc-1b4mfqp-1"
})(["padding-bottom:", ";font-size:", ";line-height:", ";font-weight:", ";letter-spacing:-1.28px;@media (max-width:", "){padding:", " 0;}"], spacer40, heading2FontSize, heading2LineHeightSmall, cta1FontWeight, screenXxsMax, spacer16);
var ItemWrapper = styled(Link).withConfig({
  displayName: "RelatedStoriesListModule__ItemWrapper",
  componentId: "sc-1b4mfqp-2"
})(["display:flex;flex-direction:row;padding-bottom:", ";:last-child{padding-bottom:0;}@media (max-width:", "){padding-bottom:", ";}&:hover{h1{color:", ";}img{", ";transition:transform 0.3s ease-in-out;}svg{", ";transition:transform 0.3s ease-in-out;opacity:0.8;}}"], spacer32, screenXxsMax, spacer16, function (props) {
  var _props$theme$link;

  return hexToRgba(((_props$theme$link = props.theme.link) === null || _props$theme$link === void 0 ? void 0 : _props$theme$link.color) || white, 0.75);
}, transformScaleUp, transformScaleUp);
var Title = styled(Type.h1).attrs({
  variant: Type.heading2
}).withConfig({
  displayName: "RelatedStoriesListModule__Title",
  componentId: "sc-1b4mfqp-3"
})(["padding-bottom:", ";max-height:", ";display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;@media (max-width:", "){max-height:", ";-webkit-line-clamp:2;}@media (max-width:", "){max-height:", ";}@media (max-width:", "){font-size:", ";line-height:", ";max-height:", ";-webkit-line-clamp:2;}"], spacer16, spacer40, screenSmMax, spacer80, screenXsMax, spacer72, screenXxsMax, heading4FontSize, heading4LineHeight, spacer48);
var Description = styled(Type.h1).attrs({
  variant: Type.heading4
}).withConfig({
  displayName: "RelatedStoriesListModule__Description",
  componentId: "sc-1b4mfqp-4"
})(["max-height:", ";display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;@media (max-width:", "){display:none;}"], spacer56, screenSmMax);
var ImageContainer = styled(ImageWrapper).withConfig({
  displayName: "RelatedStoriesListModule__ImageContainer",
  componentId: "sc-1b4mfqp-5"
})(["width:20%;height:unset;overflow:hidden;@media (max-width:", "){width:40%;}@media (max-width:", "){width:35%;svg{height:", ";width:", ";bottom:", ";left:", ";}}}"], screenMdMin, screenXxsMax, spacer20, spacer20, spacer4, spacer4);
var TextWrapper = styled.div.withConfig({
  displayName: "RelatedStoriesListModule__TextWrapper",
  componentId: "sc-1b4mfqp-6"
})(["padding-left:", ";width:70%;display:flex;flex-direction:column;justify-content:center;color:", ";@media (max-width:", "){padding-left:", ";width:55%;}@media (max-width:", "){padding-left:", ";width:55%;}"], spacer40, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
}, screenMdMin, spacer16, screenXxsMax, spacer8);
var TRACK_CAT = 'module-relatedStoriesModule';
export var RelatedStoriesListModule = function RelatedStoriesListModule(_ref3) {
  var _ref3$headline = _ref3.headline,
      headline = _ref3$headline === void 0 ? '' : _ref3$headline,
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      _ref3$themeName = _ref3.themeName,
      themeName = _ref3$themeName === void 0 ? 'whiteOnBlack' : _ref3$themeName;
  var locale = useLocale();
  var relatedStories = items.map(function (item) {
    return itemToSearchHit(item, locale);
  }).filter(Boolean);
  return (relatedStories === null || relatedStories === void 0 ? void 0 : relatedStories.length) && /*#__PURE__*/_jsxs(RelatedStoriesList, {
    themeName: themeName,
    children: [/*#__PURE__*/_jsx(StyledSupertext, {
      children: headline
    }), relatedStories.map(function (item, index) {
      return /*#__PURE__*/_jsxs(ItemWrapper, {
        track: [TRACK_CAT, 'Related Stories'],
        href: item.url,
        children: [/*#__PURE__*/_jsx(ImageContainer, {
          video: item.contentType === 'videoPage',
          featured: false,
          children: item.image && /*#__PURE__*/_jsx(ContentfulImage, {
            asset: item.image,
            children: /*#__PURE__*/_jsx(IconPlay, {
              "aria-hidden": true
            })
          })
        }), /*#__PURE__*/_jsxs(TextWrapper, {
          children: [/*#__PURE__*/_jsx(Title, {
            children: item.title
          }), /*#__PURE__*/_jsx(Description, {
            children: item.description
          })]
        }, "text-".concat(item.id, "-").concat(index))]
      }, "link-".concat(item.id, "-").concat(index));
    })]
  }) || /*#__PURE__*/_jsx(_Fragment, {});
};